import axios, { AxiosResponse } from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'

// 创建 axios 实例
const service = axios.create({
  // DesignChange: 后端接口地址
  // baseURL: 'http://192.168.2.40:9999',
  baseURL: 'https://supply.aishanyin.com/',
  // baseURL: 'https://supply.aishanyin.com/',
  // baseURL: 'https://design-new.aishanyin.com',
  // baseURL: import.meta.env.VITE_APP_BASE_API || '/',
  timeout: 500000,
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
})

// 请求拦截器
service.interceptors.request.use(
  (config: any) => {
    if (!config.headers) {
      throw new Error(`Expected 'config' and 'config.headers' not to be undefined`)
    }
    const token = localStorage.getItem('matchToken')
    // const type = localStorage.getItem('ACCESS_TOKEN_TYPE') || 'Bearer'

    // const token = '708|01RWXcHNSbvuEsIsjPMw92kZ8fZZCSIS21DwT8HLfa6fa504'
    const type = 'Bearer'
    if (token) {
      config.headers.Authorization = `${type} ${token}`
    }
    return config
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response: AxiosResponse) => {
    const { code, msg } = response.data
    if (code == 200) {
      return response
    } else if (code === 401) {
      localStorage.removeItem('ACCESS_TOKEN')
      localStorage.removeItem('ACCESS_TOKEN_TYPE')
      localStorage.removeItem('ACCESS_TOKEN_EXPIRE_TIME')
      window.location.href = '/admin'
      return response
    } else if (code === 404) {
      // ElMessage({
      //   message: msg || '系统出错',
      //   type: 'error'
      // })
      return response
    } else {
      // 响应数据为二进制流处理(Excel导出)
      if (response.data instanceof ArrayBuffer) {
        return response
      }
      if (response.data instanceof Array) {
        return response
      }
      if (response.config.url != '/api/saveCanvasData') {
        // 如果是保存画布数据的接口不提示错误
        ElMessage({
          message: msg || '系统出错',
          type: 'error'
        })
      }

      return Promise.reject(new Error(msg || 'Error'))
    }
  },
  (error: any) => {
    console.log('error:', error)
    if (error.response.data) {
      const { detail, code, msg } = error.response.data
      console.log('data:', error.response.data)
      if (code === 401) {
        localStorage.removeItem('ACCESS_TOKEN')
        localStorage.removeItem('ACCESS_TOKEN_TYPE')
        localStorage.removeItem('ACCESS_TOKEN_EXPIRE_TIME')
        window.location.href = '/admin'
        ElMessage({
          message: msg || '系统出错',
          type: 'error'
        })
      }
      if (code === 403) {
        ElMessage({
          message: '当前页面已失效，请重新登录',
          type: 'error'
        })
        // DesignChange: 隐藏登录弹窗
        // localStorage.clear()
        // const userStore = useUserStore()
        // userStore.setLoginVisible(true)
        return error.response
      }
      if (code < 500) {
        ElMessage({
          message: msg || '系统出错',
          type: 'error'
        })
        return error.response
      }
      // token 过期,重新登录
      if (detail === 'Signature has expired.') {
        ElMessageBox.confirm('当前页面已失效，请重新登录', 'Warning', {
          confirmButtonText: 'OK',
          type: 'warning'
        }).then(() => {
          localStorage.clear()
          window.location.href = '/admin'

        })
      } else {
        ElMessage({
          message: detail || '系统出错',
          type: 'error'
        })
      }
    }
    return Promise.reject(error.message)
  }
)

// 导出 axios 实例
export default service
